import { type SceneControl, lib, use } from '@anov/3d-core'

const { CopyShader, ShaderPass, BrightnessContrastShader } = lib

const addBrightnessContrastPass = (brightness = 0.5, sceneControl: SceneControl) => {
  const { scene, camera } = use.useScene(sceneControl)
  const composer = sceneControl.context.storeManagement.get('composer') as lib.EffectComposer | undefined

  if (!scene || !camera)
    throw new Error('scene or camera is not defined,')

  if (!composer)
    throw new Error('composer is not defined, please initPostEffects first')

  const effectCopy = new ShaderPass(CopyShader)
  effectCopy.renderToScreen = true

  BrightnessContrastShader.uniforms.brightness.value = brightness

  const brightnessContrastPass = new ShaderPass(BrightnessContrastShader)

  composer.addPass(effectCopy)
  composer.addPass(brightnessContrastPass)

  return {
    clean: () => {
      composer.removePass(effectCopy)
      composer.removePass(brightnessContrastPass)
    },

  }
}

export default addBrightnessContrastPass